<script lang="ts">
	//UI
	import StoreNameValue from "@hitit/hub/src/v7/components/store/StoreNameValue.svelte";
	import RegistrationImage from "./RegistrationImage.svelte";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import {
		formatKoreanRegistrationNumberHandler,
		addKoreanRegisterSpacer,
	} from "@hitit/hub/src/v7/utils";
	//Props
	export let editmode = false;

	export let linkedMemberShip = "";
	export let membership_status = "";
	export let registrationNumber = "";
	export let registrationImage = "";
	export let ownername = "";
	export let storeType = "";
	export let storeName = "";
	export let storeClass = "";
	export let storeAddr = "";
	export let contactName = "";
	export let contactEmail = "";
	export let contactPhone = "";
	// Variables

	//Functions
	function idHanlder(_: HTMLElement, replacedValue: string) {
		registrationNumber = replacedValue;
	}
</script>

<div class="container">
	<div class="registration-image">
		<div class="title-wrapper">
			<img src="/img/icons/korea-registration.png" alt="description" />
			<h3>{$t("hub.store.ko_registration.info")}</h3>
		</div>
		<RegistrationImage editmode={editmode} bind:imageaddr={registrationImage} />
	</div>
	<!-- 국세청 등록 여부 -->
	<div class="name-value">
		<StoreNameValue
			name={$t("hub.store.ko_registration.membership_status")}
			value={membership_status === "TRUE" ? "TRUE" : "FALSE"}
		/>
	</div>
	<!-- 상호 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={storeName}
			name={$t("hub.store.ko_registration.name")}
			editmode={editmode}
		/>
	</div>
	<!-- 사업자 번호 -->
	<div class="name-value">
		<StoreNameValue
			length={12}
			on:input={(e) => formatKoreanRegistrationNumberHandler(e, idHanlder)}
			value={addKoreanRegisterSpacer(registrationNumber)}
			name={$t("hub.store.ko_registration.id")}
			editmode={editmode}
		/>
	</div>
	<!-- 대표자 성명 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={ownername}
			name={$t("hub.store.ko_registration.ownername")}
			editmode={editmode}
		/>
	</div>

	<!-- 사업자 등록증상 주소 -->

	<StoreNameValue
		bind:value={storeAddr}
		name={$t("hub.store.ko_registration.address")}
		editmode={editmode}
	/>

	<!-- 업태 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={storeType}
			name={$t("hub.store.ko_registration.type")}
			editmode={editmode}
		/>
	</div>
	<!-- 종목 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={storeClass}
			name={$t("hub.store.ko_registration.class")}
			editmode={editmode}
		/>
	</div>
	<!-- 담당자 성명 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={contactName}
			name={$t("hub.store.ko_registration.contact_name")}
			editmode={editmode}
		/>
	</div>

	<!-- 담당자 번호 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={contactPhone}
			name={$t("hub.store.ko_registration.contact_phonenumber")}
			editmode={editmode}
		/>
	</div>

	<!-- 담당자 이메일 -->
	<div class="name-value">
		<StoreNameValue
			bind:value={contactEmail}
			name={$t("hub.store.ko_registration.contact_email")}
			editmode={editmode}
		/>
	</div>
	<!-- 공유 사업자 여부 -->
	<div class="name-value">
		<StoreNameValue
			name={$t("hub.store.ko_registration.is_linked_membership")}
			value={linkedMemberShip === "TRUE" ? "TRUE" : "FALSE"}
		/>
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		position: relative;
		.name-value {
			width: 100%;
		}

		.registration-image {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 100%;
		}

		.title-wrapper {
			display: flex;
			gap: 10px;

			img {
				width: 24px;
				height: 24px;
			}

			h3 {
				font-size: 1.25rem;
				font-weight: 500;
				color: #46474b;
			}
		}

		#open-button {
			width: 27.8px;
			height: 14px;
			position: absolute;
			top: 4px;
			right: 0px;

			&:hover {
				cursor: pointer;
			}

			&.openRegistration {
				bottom: 0px;
				top: auto;
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px 0px;
			padding-bottom: 24px;

			.registration-image {
				gap: 30px;
			}

			.title-wrapper {
				h3 {
					font-size: 1.5rem;
				}
			}

			#open-button {
				top: auto;
				right: auto;
				bottom: 0px;
				left: 50%;
				transform: translate(-50%, 0%);
			}

			.name-value {
				width: 50%;
				max-width: 50%;
			}
		}
	}
</style>
